// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__UVWJH","header":"ClearentDisclaimer_header__1hQfJ","inner":"ClearentDisclaimer_inner__zT34G"};